/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import Flex from '@deprecated-ui/common/Flex';
import Modal from '@deprecated-ui/common/Modal';
import BaseInputNumber from '@deprecated-ui/trading/InputNumber';
import color from '@deprecated-ui/_style/color';
import { Skeleton } from 'antd';
import styled from 'styled-components';
import { formatNumber } from 'utils/number';

export const TitleSkeleton = styled(Skeleton).attrs({
  paragraph: { rows: 0 },
})`
  margin: 0;
  & .ant-skeleton-title {
    margin: 0;
  }

  & .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
    margin: 0;
  }
`;

export const ContentSkeleton = styled(Skeleton)`
  & .ant-skeleton-title {
    margin: 0;
  }

  & .ant-skeleton-paragraph {
    margin-bottom: 0;
  }

  & .ant-skeleton-content .ant-skeleton-paragraph > li + li {
    margin-top: 12px;
  }
`;

export const AutoOrderModal = styled(Modal)`
  & .ant-modal-content {
    border-radius: 3px;
  }
`;

export const ListWrapper = styled.div`
  padding: 40px 20px 20px;
`;

export const AutoOrderFieldWrapper = styled.div`
  & > div {
    border-bottom: 1px solid ${color.downgray};

    &:last-child {
      border: 0;
    }
  }
`;
export const AutoOrderFieldGroup = styled.div`
  padding: 16px 20px;
`;

export const Option = styled(Flex).attrs({
  as: 'button',
  p: '20px',
  justify: 'space-between',
  align: 'center',
  className: 'button-unstyled',
})`
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid ${color.component};
  }

  &:hover {
    background: ${color.aliceBlue};
  }
`;

export const InputNumber = styled(BaseInputNumber).attrs({
  formatter: (value) => formatNumber(value),
  parser: (value) => value.replace(/[, ]+/g, '').trim(),
})`
  margin-right: 30px;
  width: ${(props) =>
    // @ts-expect-error
    props.isForTriggerPrice ? '63px !important' : '100px !important'};

  .ant-input-number-input {
    padding: 0px !important;
  }

  .ant-input-number-handler-wrap {
    width: 0px !important;
  }

  .ant-input-number-handler-up {
    border-left: 1px solid ${color.gainsboro};
    left: ${(props) =>
      // @ts-expect-error
      props.isForTriggerPrice ? '-1px !important' : '0px !important'};
  }

  .ant-input-number-handler-down {
    border-right: 1px solid ${color.gainsboro};
    left: ${(props) =>
      // @ts-expect-error
      props.isForTriggerPrice ? '-91px !important' : '-130px !important'};
  }
`;

export const InfoMenuButton = styled.button.attrs({
  className: 'button-unstyled',
})`
  padding: 0;
`;
